export default [
  //订单管理

  {
  	path: '/productionBasismanag/moneyset',
  	name: 'moneyset',
  	component: () => import('@/components/productionDelivery/moneyset')
  },

  {
  	path: '/daliangset',
  	name: 'daliangset',
  	component: () => import('@/components/productionDelivery/daliangset')
  },

  {
  	path: '/order_question',
  	name: 'order_question',
  	component: () => import('@/components/orderManagement/order_question')
  },

  //订单维系
  {
    path: '/dingdanweixi',
    component: () => import('@/views/dingdanweixi/index'),
    redirect: '/dingdanweixi/dingdanweixi',
    children: [
      {
        path: '/dingdanweixi/dingdanweixi',
        component: () => import('@/views/dingdanweixi/dingdanweixi'),
        mete: {
          title: "订单维系",
        },
      },
      {
        path: '/dingdanweixi/dingdanweixi2',
        component: () => import('@/views/dingdanweixi/dingdanweixi2'),
        mete: {
          title: "订单维系",
        },
      },
    ]
  },
  {
    path: '/order_export_weixi',
    name: 'order_export_weixi',
    component: () => import('@/components/productionManagement/order_export_weixi')
  },
  {
    path: '/yongjinzhichu/order_export_yongjinzhichu',
    name: 'order_export_yongjinzhichu',
    component: () => import('@/components/productionManagement/order_export_yongjinzhichu')
  },
  {
    path: '/yongjinzhichu/daijiesuanjilu',
    name: 'daijiesuanjilu',
    component: () => import('@/components/productionManagement/daijiesuanjilu')
  },

  {
  	path: '/order_question/old_dingdan',
  	name: 'old_dingdan',
  	component: () => import('@/components/orderManagement/old_dingdan')
  },


  {
  	path: '/order_question/old_Other',
  	name: 'old_Other',
  	component: () => import('@/components/orderManagement/old_Other')
  },

  {
  	path: '/order_question/orderOther',
  	name: 'orderOther',
  	component: () => import('@/components/orderManagement/orderOther')
  },
  {
  	path: '/failOrder',
  	name: 'failOrder',
  	component: () => import('@/components/orderManagement/failOrder')
  },
  {
  	path: '/orderImport',
  	name: 'orderImport',
  	component: () => import('@/components/orderManagement/orderImport')
  },
  {
  	path: '/orderImport/order_hand',
  	name: 'order_hand',
  	component: () => import('@/components/orderManagement/order_hand')
  },
  {
  	path: '/orderImport/nocopy',
  	name: 'nocopy',
  	component: () => import('@/components/orderManagement/nocopy')
  },
  {
  	path: '/orderManagement',
  	name: 'orderManagement',
  	component: () => import('@/components/orderManagement/orderManagement')
  },
  {
  	path: '/orderDo',
  	name: 'orderDo',
  	component: () => import('@/components/orderManagement/orderDo')
  },
  {
  	path: '/order_question/orderDetail',
  	name: 'orderDetail',
  	component: () => import('@/components/orderManagement/orderDetail')
  },
  {
  	path: '/order_question/lanjie',
  	name: 'lanjie',
  	component: () => import('@/components/orderManagement/lanjie')
  },
  {
  	path: '/productionDelivery/productionOther',
  	name: 'productionOther',
  	component: () => import('@/components/productionDelivery/productionOther')
  },
  {
  	path: '/productionDelivery',
  	name: 'productionDelivery',
  	component: () => import('@/components/productionDelivery/productionDelivery')
  },
  {
  	path: '/productionDelivery/productionDeliverysale',
  	name: 'productionDeliverysale',
  	component: () => import('@/components/productionDelivery/productionDeliverysale')
  },

]



// WEBPACK FOOTER //
// ./src/router/dingdan.js